import { render, staticRenderFns } from "./Program_New.vue?vue&type=template&id=39a40e4a&"
import script from "./Program_New.vue?vue&type=script&lang=js&"
export * from "./Program_New.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports